import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';
import { SnowflakePushDataProgressProps } from '../../../types/reduxTypes/snowflakePushDataProgress';

const createReducer = <T extends SliceCaseReducers<SnowflakePushDataProgressProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setSnowflakePushDataProgressData(state, action) {
    state.snowflakePushDataProgressData = action.payload;
  }
});

export default reducers;